import React, { useEffect, useState } from 'react'
import { Space, Table, Flex } from 'antd';
import Main from '../../../cpn/Main';
import IncomeTypeEdit from './IncomeTypeEdit';    
import IncomeTypeAdd from './IncomeTypeAdd';
import { useShoukuanlxListQuery } from '../../../store/DianShangYeWuApi';
import IncomeTypeDel from './IncomeTypeDel';
function IncomeTypeList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useShoukuanlxListQuery({sklx_qy_id:qy_id,});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {sklx_id:key,sklx_name,sklx_uname,sklx_ctime} = item;                 
                    return item = {key,sklx_name,sklx_uname,sklx_ctime}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.yh_ctime;
                    let bTimeString = b.yh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'sklx_name',
            title: '名称',            
            dataIndex: 'sklx_name',
        },              
        {
            key: 'sklx_ctime',
            title: '新增',            
            dataIndex: 'sklx_ctime',
            render:(text,record) => {
                return<>{text} {record.sklx_uname}</>
            }
        },   
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space align='center' size='middle'>
                        <IncomeTypeEdit
                            sklx_id={record.key} 
                            sklx_name={record.sklx_name} 
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                        />
                        <IncomeTypeDel
                            sklx_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/IncomeTypeList']}>                       
            <Flex>
                <IncomeTypeAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className="custom-table"
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default IncomeTypeList
